var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"mb-4",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"lg":"auto","md":"1","sm":"1","cols":"1"}},[_c('img',{attrs:{"src":_vm.imgSrc}})]),_c('b-col',{staticClass:"pl-4"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }